// extracted by mini-css-extract-plugin
export var container = "_bg-0";